import styled from 'styled-components';

export const TagCol: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 80%;
`;
